<template>
  <div>
    <b-card no-body>
      <b-tabs card>
        <b-tab active>
          <template slot="title">
            <tab-item
              icon="info-circle"
              heading="Step 1"
              subheading="Details"
            ></tab-item>
          </template>
          <div class="form-panel">
            <b-row>
              <b-col sm="3">
                <strong>Details</strong>
                <p class="muted">
                  Enter the general details of this community partner here.
                </p>
              </b-col>
              <b-col sm="9">
                <b-form class="form-horizontal">
                  <b-form-radio
                    style="margin-top: 18px; margin-bottom: 15px"
                    name="strategicPartnership"
                    v-model="form.strategicPartnership"
                    :value="false"
                    >Not strategic partnership</b-form-radio
                  >
                  <b-form-radio
                    style="margin-top: 18px; margin-bottom: 15px"
                    name="strategicPartnership"
                    v-model="form.strategicPartnership"
                    :value="true"
                    >Strategic partnership</b-form-radio
                  >

                  <b-form-group
                    label="Name"
                    label-class="control-label form-label"
                    :class="{ 'invalid-group': $v.form.name.$error }"
                  >
                    <autocomplete
                      :source="sitesApi"
                      :inputClass="{
                        'form-control': true,
                        'is-invalid': $v.form.name.$error,
                      }"
                      resultsValue="name"
                      :resultsDisplay="siteDisplay"
                      ref="siteAutocomplete"
                      @selected="selectSite"
                      credentials="include"
                      :request-headers="requestHeaders"
                      @displayChanged="updateName"
                    ></autocomplete>
                    <span
                      class="span-feedback invalid-feedback"
                      v-if="
                        $v.form.name.$error &&
                        (form.name == null || form.name.length == 0)
                      "
                      >You must enter a name.</span
                    >
                    <span
                      class="span-feedback invalid-feedback"
                      v-if="
                        $v.form.name.$error && form.name && form.name.length > 0
                      "
                      >There is already a community partner with this
                      name.</span
                    >
                  </b-form-group>

                  <b-form-group
                    label="Address"
                    label-class="control-label form-label"
                  >
                    <b-form-input
                      @change="searchCoordinates()"
                      v-model="form.address"
                      type="text"
                      placeholder="Street and number, P.O. box, c/o."
                    ></b-form-input>
                    <b-form-input
                      v-model="form.address2"
                      @change="searchCoordinates()"
                      type="text"
                      class="my-1"
                      placeholder="Apartment, suite, unit, building, floor, etc. (optional)"
                    ></b-form-input>
                    <b-form-input
                      @change="searchCoordinates()"
                      v-model="form.address3"
                      type="text"
                      placeholder="International address information (optional)"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="City"
                    label-class="control-label form-label"
                  >
                    <b-form-input
                      v-model="form.city"
                      @change="searchCoordinates()"
                      type="text"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="State"
                    label-class="control-label form-label"
                  >
                    <b-form-input
                      v-model="form.state"
                      @change="searchCoordinates()"
                      type="text"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="ZIP"
                    label-class="control-label form-label"
                  >
                    <b-form-input
                      v-model="form.zip"
                      @change="searchCoordinates()"
                      type="text"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Country"
                    label-class="control-label form-label"
                  >
                    <b-form-input
                      v-model="form.country"
                      @change="searchCoordinates()"
                      type="text"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Latitude"
                    label-class="control-label form-label"
                  >
                    <b-form-input
                      v-model="form.lat"
                      placeholder="Latitude"
                      @change="searchCoordinates()"
                      @input="form.lat = parseFloat(form.lat)"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Longitude"
                    label-class="control-label form-label"
                  >
                    <b-form-input
                      v-model="form.lon"
                      placeholder="Longitude"
                      @change="searchCoordinates()"
                      @input="form.lon = parseFloat(form.lon)"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Website"
                    label-class="control-label form-label"
                  >
                    <b-form-input
                      v-model="form.website"
                      type="text"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Phone"
                    label-class="control-label form-label"
                  >
                    <b-form-input
                      v-model="form.phone"
                      type="text"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Type"
                    label-class="control-label form-label"
                  >
                    <b-form-select
                      :options="types"
                      v-model="form.communityPartnerTypeId"
                      value-field="id"
                      text-field="name"
                    ></b-form-select>
                  </b-form-group>
                </b-form>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <tab-item
              icon="file-alt"
              heading="Step 2"
              subheading="Description"
            ></tab-item>
          </template>
          <div class="form-panel">
            <b-row>
              <b-col sm="3">
                <strong>Description</strong>
                <p>Enter the community partner description here.</p>
              </b-col>
              <b-col sm="9">
                <b-form class="form-horizontal">
                  <b-form-group
                    label="Description"
                    label-class="control-label form-label"
                  >
                    <vue-editor
                      id="descriptionEditor"
                      v-model="form.description"
                    ></vue-editor>
                  </b-form-group>
                </b-form>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab>
          <template slot="title">
            <tab-item
              icon="file-invoice-dollar"
              heading="Step 3"
              subheading="Sponsored Awards"
            ></tab-item>
          </template>
          <div class="form-panel">
            <b-row>
              <b-col sm="3">
                <strong>Awards</strong>
                <p>Select any awards associated with this community partner.</p>
              </b-col>
              <b-col sm="9">
                <b-form class="form-horizontal">
                  <autocomplete-form
                    v-model="form.awards"
                    :displayFunction="displayAward"
                    apiPath="/api/Awards?search="
                    objectName="Award"
                  >
                  </autocomplete-form>
                </b-form>
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-button variant="primary" class="pull-right my-2" @click="submit()"
      ><font-awesome-icon icon="check" /> Submit</b-button
    >
  </div>
</template>
<script>
import TabItem from "../../components/menu/tab-item";
import { required } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
import Autocomplete from "../../components/autocomplete";
import AutocompleteFormWrapper from "../autocomplete-form-wrapper";
import { OpenStreetMapProvider } from "leaflet-geosearch";
const provider = new OpenStreetMapProvider();
var htmlEncode = require("js-htmlencode").htmlEncode;
var htmlDecode = require("js-htmlencode").htmlDecode;

// custom validator
function isNewName(value) {
  if (!value) {
    return true;
  }
  return (
    _.findIndex(this.existingCommunityPartners, function (communityPartner) {
      return communityPartner.name.toLowerCase() == value.toLowerCase();
    }) == -1
  );
}
export default {
  data() {
    return {
      form: {
        name: null,
        description: null,
        address: null,
        address2: null,
        address3: null,
        city: null,
        state: null,
        zip: null,
        country: null,
        website: null,
        phone: null,
        awards: [],
        proposals: [],
        lat: null,
        lon: null,
        strategicPartnership: false,
      },
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" },
    };
  },

  props: {
    item: {
      type: Object,
      required: false,
    },
    types: {
      type: Array,
      required: true,
    },
  },

  components: {
    "tab-item": TabItem,
    VueEditor,
    Autocomplete,
    "autocomplete-form": AutocompleteFormWrapper,
  },

  validations: {
    form: {
      name: {
        required,
        isNewName,
      },
      strategicPartnership: { required },
    },
  },

  computed: {
    sitesApi: function () {
      return process.env.VUE_APP_BASE_URI + "/api/Sites/FindSite?query=";
    },
  },

  methods: {
    submit: function () {
      this.$v.form.$touch();

      if (!this.$v.form.$error) {
        if (this.form.description) {
          this.form.description = htmlEncode(this.form.description);
        }
        this.$emit("submit", this.form);
      }
    },
    displayAward(award) {
      return (
        award.awardTitle +
        " (" +
        award.awardNumber +
        ")<br/>" +
        "PI: " +
        award.primaryInvestigator.firstName +
        " " +
        award.primaryInvestigator.lastName
      );
    },
    siteDisplay: function (site) {
      return site.name;
    },

    selectSite: function (autoselectResponse) {
      var site = autoselectResponse.selectedObject;
      this.form.name = site.name;
      if (site.description) {
        this.form.description = htmlDecode(site.description);
      } else {
        this.form.description = "";
      }
      this.form.address = site.streetAddress;
      this.form.city = site.city;
      this.form.state = site.state;
      this.form.zip = site.zip;
      this.form.website = site.website;
      this.form.phone = site.phone;
    },

    updateName: function (query) {
      this.form.name = query;
    },
    searchCoordinates() {
      var addressString =
        (this.form.address ? this.form.address + " " : "") +
        (this.form.address2 ? this.form.address2 + " " : "") +
        (this.form.address3 ? this.form.address3 + " " : "") +
        (this.form.city ? ", " + this.form.city + ", " : "") +
        (this.form.state ? this.form.state + ", " : "") +
        (this.form.zip ? this.form.zip : "");

      // addressString = addressString.trim();

      // addressString = addressString.substring(1);
      // addressString = addressString.substring(0, addressString.length - 2);

      // console.log("????????");
      // console.log(addressString);
      // console.log("!!!!!!!!");

      if (addressString.trim().length == 0) this.clearCoordinates();

      this.getCoordinates(addressString).catch(() => {
        // try again, this time attempting to remove 'suite' or 'ste' from the address

        if (this.form.address) {
          var shortenedStreetAddress = this.form.address.replace(
            /(Suite|Ste\.|, Suite|, Ste\.).([0-9a-zA-Z])*.*/,
            ""
          );

          // if (shortenedStreetAddress.length < this.form.address.length) {
          //   addressString =
          //     shortenedStreetAddress +
          //     (this.form.city ? ", " + this.form.city + ", " : "") +
          //     (this.form.state ? this.form.state + ", " : "") +
          //     (this.form.zip ? this.form.zip : "");
          // }
        } else shortenedStreetAddress = "";

        addressString =
          shortenedStreetAddress +
          (this.form.city ? ", " + this.form.city + ", " : "") +
          (this.form.state ? this.form.state + ", " : "") +
          (this.form.zip ? this.form.zip : "");

        this.getCoordinates(addressString);
      });
    },
    clearCoordinates() {
      console.log("please wait");
      this.form.lat = null;
      this.form.lon = null;
      console.log("clear");
    },
    async getCoordinates(addressString) {
      return new Promise((resolve, reject) => {
        provider.search({ query: addressString }).then((result) => {
          if (result.length > 0) {
            this.form.lon = parseFloat(result[0].x);
            this.form.lat = parseFloat(result[0].y);
            resolve(result);
          } else {
            reject();
          }
        });
      });
    },
    loadForm(item) {
      if (item) {
        this.form = _.clone(item);
        this.form.description = htmlDecode(this.form.description);
        this.$refs.siteAutocomplete.display = this.form.name;
      }
    },
  },
  watch: {
    item: function () {
      if (this.item) {
        this.loadForm(this.item);
      }
    },
  },
  created() {
    // if (this.item != undefined) {
    //   this.loadForm(this.item);
    // }
  },
};
</script>
<style scoped></style>
